<script lang="ts" module>
  export type PixelIconName =
    | 'trophy'
    | 'swords'
    | 'bot'
    | 'lock'
    | 'timer'
    | 'crown'
    | 'medal-silver'
    | 'medal-bronze'
    | 'bolt'
    | 'infinity'
    | 'check'
    | 'close'
    | 'play'
    | 'back'
    | 'arrows'
    | 'gear'
    | 'info'
    | 'warning'
    | 'delete'
    | 'burst';
</script>

<script lang="ts">
  interface Props {
    name: PixelIconName;
    label?: string;
    size?: number;
  }

  let { name, label, size = 32 }: Props = $props();
  const symbolId = $derived(name === 'burst' ? 'burst' : `icon-${name}`);
</script>

<svg
  class="pixel-icon"
  style:--pixel-icon-size="calc({size} * var(--u) * var(--type-scale))"
  viewBox="0 0 11 11"
  shape-rendering="crispEdges"
  aria-hidden={label ? undefined : 'true'}
  role={label ? 'img' : undefined}
  aria-label={label}
  focusable="false"
>
  <use href="#{symbolId}"></use>
</svg>
